import React from "react";

const Puller = () => {
  return (
    <div className={'absolute w-[80px] left-0 right-0 h-[3px] bg-primary mt-4 mx-auto z-10 rounded'}></div>
  )
}

export default Puller;